import { render, staticRenderFns } from "./QutaRawMater.vue?vue&type=template&id=14c39da7&scoped=true&"
import script from "./QutaRawMater.vue?vue&type=script&lang=js&"
export * from "./QutaRawMater.vue?vue&type=script&lang=js&"
import style0 from "./QutaRawMater.vue?vue&type=style&index=0&id=14c39da7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c39da7",
  null
  
)

export default component.exports